import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'app-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.scss']
})
export class JobsComponent implements OnInit {
  Experiences: any[] = [
    {
      Tab: 'ElifCS',
      Name:'Elif Consultancy & Services',
      Title: 'Software Developer',
      Date: 'Aug 2023 – present',
      Description: [
        'Software Developer at elifcs,  developing systems, interfaces, and technological solutions to make the web a better place.'
        
      ]
    },

  ];
  active = 0
  
  constructor(
    public analyticsService: AnalyticsService
  ) { }

  ngOnInit(): void {
  }

}
